import React, { useEffect, useRef, useState } from 'react';
import CustomTitle from '../../../components/UI/title/CustomTitle';
import './style.scss'
import { Helmet } from 'react-helmet';
import { useHistory, useLocation } from 'react-router-dom';
import mixpanel from 'mixpanel-browser';
import Cookies from 'js-cookie';
import useFaceBook from '../../../hooks/useFaceBook';
import useMixpanel from '../../../hooks/useMixpanel';
import 'swiper/swiper-bundle.css';
import Header from './component/Header/Header';
import HeroSection from './component/HeroSection/HeroSection';
import GenerateSection from './component/GenerateSection/GenerateSection';
import ModelSection from './component/ModelSection/ModelSection';
import SliderSection from './component/SliderSection/SliderSection';
import ProLevel from './component/ProLevelCard.jsx/ProLevel';
import AiSoraVideo from './component/animations/ai-sora-video/AiSoraVideo';
import AiClip from './component/animations/ai-clip/AiClip';
import AiVideoAd from './component/animations/ai-video-ad/AiVideoAd';
import AiAvatarVideo from './component/animations/ai-avatar-video/AiAvatarVideo';
import CreateSection from './component/CreateSection/CreateSection';
import Footer from './component/Footer/Footer';
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const Landing = ({ setIsHomePage }) => {
    const history = useHistory();

    const { pathname } = useLocation();

    const { trackP1Event } = useMixpanel();
    useEffect(() => {
        if (setIsHomePage) {
            setIsHomePage(pathname === '/');
        }
    }, [pathname])


    const params = new URLSearchParams(window.location.search);
    let visitorId = params.get("visitor_id") || Cookies.get("visitor_id");
    if (visitorId) params.set("visitor_id", visitorId);



    if (!visitorId) {
        visitorId = crypto.randomUUID();

    }
    Cookies.set("visitor_id", visitorId, { expires: 365 });

    const newUrl = params.toString()
        ? `${window.location.pathname}?${params.toString()}`
        : `${window.location.pathname}`;

    window.history.replaceState({}, '', newUrl);

    function documentFontSize() {
        if (window.innerWidth > 991 && window.innerWidth < 1800) {
            document.documentElement.style.fontSize = 'calc(100vw / 1440)';
        } else if (window.innerWidth > 1799) {
            document.documentElement.style.fontSize = '1.2px';
        } else {
            document.documentElement.style.fontSize = '';
        }
    }

    useEffect(() => {

        documentFontSize()
    }, []);

    const [isVisible, setIsVisible] = useState(window.innerWidth > 991);

    useEffect(() => {
        const handleResize = () => {
            setIsVisible(window.innerWidth > 991);
            documentFontSize()
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const { sendFb } = useFaceBook();

    useEffect(() => {

        if (mixpanel.__loaded) {
            trackStart();
        } else {
            const checkLoaded = setInterval(() => {
                if (mixpanel.__loaded) {
                    clearInterval(checkLoaded);
                    trackStart();
                }
            }, 100);
        }

        function trackStart() {

            if (window.location.pathname === process.env.REACT_APP_BASENAME + '/') {
                sendFb("PageView", {});

                trackP1Event("web_start_view", {})

            }
        }
    }, []);







    const [isDark, setIsDark] = useState(true)


    useEffect(() => {
        gsap.registerPlugin(ScrollTrigger);

        const sections = gsap.utils.toArray("[data-theme]");
        const root = document.documentElement;

        sections.forEach((section) => {
            ScrollTrigger.create({
                trigger: section,
                start: "top top",
                end: "bottom top",

                onEnter: () => {
                    const theme = section.dataset.theme;
                    root.setAttribute("data-theme", theme);
                    setIsDark(theme === "dark");
                    console.log("enter", theme);
                },

                onEnterBack: () => {
                    const theme = section.dataset.theme;
                    root.setAttribute("data-theme", theme);
                    setIsDark(theme === "dark");  // ← ЭТО НУЖНО
                    console.log("enterBack", theme);
                },
            });
        });

        return () => ScrollTrigger.getAll().forEach((t) => t.kill());
    }, []);



    const slides = [
        { source: 'button_6', animation: <AiSoraVideo />, title: 'Sora 2 video ad', text: 'Transform your image into a cinematic video ad with SORA 2 realism. Perfect for viral impact and premium campaigns.' },
        { source: 'button_7', animation: <AiClip />, title: 'Image to video', text: 'Drop your image in and get a dynamic short video with striking effects. Perfect for stories, reels, or campaign edits.' },
        { source: 'button_8', animation: <AiVideoAd />, title: 'Marketing video ad', text: 'Let an AI avatar present your product in a viral, UGC-inspired video that looks real, feels engaging, and drives attention.' },
        { source: 'button_9', animation: <AiAvatarVideo />, title: 'Text to speech', text: 'Turn any script into a lifelike talking head video. Perfect for warm-ups, intros, or story segments inside your video ad.' },
    ];

    const slidesSecond = [
        { source: 'button_18', img: 'landing/ls1.webp', title: 'Small business owners', text: 'Forget juggling marketing and design. Zeely AI turns your ideas into campaigns that grow your business.' },
        { source: 'button_19', img: 'landing/ls2.webp', title: 'Content creators', text: 'Create more, edit less. Zeely connects top AI models so you can produce standout content fast.' },
        { source: 'button_20', img: 'landing/ls3.webp', title: 'Agencies & freelancers', text: 'Deliver better results in less time. Zeely’s smart templates and automation help you scale creative output fast.' },
    ];


    const [scroll, setScoll] = useState(0);

    const handleClick = (value) => {

        trackP1Event("web_start", {
            web_start: value,
            scroll: scroll
        })

        setTimeout(() => {
            history.push({
                pathname: '/signup',
                search: `?${params.toString()}`,
            });
        }, 150);
    }

    useEffect(() => {
        let maxReached = 0;

        const checkpoints = [0, 25, 50, 75, 100];

        const onScroll = () => {
            const scrollTop = window.scrollY;
            const docHeight = document.documentElement.scrollHeight - window.innerHeight;
            const percent = Math.round((scrollTop / docHeight) * 100);

            checkpoints.forEach((cp) => {
                if (percent >= cp && cp > maxReached) {
                    console.log("Reached:", cp + "%");

                    maxReached = cp;
                    setScoll(cp);
                }
            });
        };

        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);
    return (
        <>
            <div className="landing">
                <Header onClick={handleClick} isDark={isDark} />
                <HeroSection handleClick={handleClick} isVisible={isVisible} />
                <GenerateSection handleClick={handleClick} isVisible={isVisible} />
                <ModelSection handleClick={handleClick} />
                <SliderSection isVisible={isVisible} column={'2'} handleClick={handleClick} slides={slides} style={{ background: 'rgba(242, 244, 246, 0.5)' }} title={isVisible ? 'Go from invisible to unforgettable<br> in the time it takes to make a coffee' : 'Go from invisible to unforgettable in the time<br>it takes to make a coffee'} text={'Use top-tier generative AI tools for images and videos, tuned specifically for ads and socials'} />
                <ProLevel isVisible={isVisible} handleClick={handleClick} />
                <SliderSection isVisible={isVisible} column={'3'} handleClick={handleClick} slides={slidesSecond} style={{ background: '#fff', zIndex: '1' }} title={'Design like a pro.<br>No need to be one.'} text={'From quick TikTok and Reels to full-scale brand campaigns, Zeely AI covers it all'} />
                <CreateSection handleClick={handleClick} isVisible={isVisible} />
                <GenerateSection handleClick={handleClick} isVisible={isVisible} secondSection={true} />
                <Footer isVisible={isVisible} />
            </div>
        </>
    );
}

export default Landing;
